export enum Gender {
    MALE = "Male",
    FEMALE = "Female",
    NON_BINARY = "Non-binary",
}